import { useCallback, useContext, useEffect } from "react"
import ModelElements from "../ModelElements"
import { ProductModelProps } from "../ModelViewerProduct"
import ProductTextureContext from "../_contexts/ProductTextureContext"
import useGLB from "../_hooks/useGLB"
import { FindMaterial } from "../../Common/Utils/ThreeTools"

export default function PillowCase(props: ProductModelProps) {
    const getUrl = useCallback(() => {
        return {
            '18x18': new URL('@resources/3d-models/glb/pillow-case-18x18.glb', import.meta.url),
            '22x22': new URL('@resources/3d-models/glb/pillow-case-22x22.glb', import.meta.url),
            '24x12': new URL('@resources/3d-models/glb/pillow-case-24x12.glb', import.meta.url),
            '20x14': new URL('@resources/3d-models/glb/pillow-case-20x14.glb', import.meta.url),
            '26x20': new URL('@resources/3d-models/glb/pillow-case-26x20.glb', import.meta.url),
        }[props.variant]
    }, [props.variant])
    
    const model = useGLB(getUrl() || new URL(''))
    const elements = model.scene.children
    const [productTexture] = useContext(ProductTextureContext)
    
    // Apply lab texture
    useEffect(() => {
        if (!elements) return
        let mat = FindMaterial('product', elements)
        if(mat){
            mat.map = productTexture
            mat.map.flipY = false
            mat.map.needsUpdate = true
        }
    }, [productTexture, elements])
    
    return <ModelElements scene={model.scene} forceUpdate={props.variant}/>
}